module.exports = __webpack_public_path__ + "img/burger-glass.2c7152cf.svg";